export default __webpack_public_path__ + "static/media/preview_image.2454b785.png";